
export const COURSES_CATEGORIES = ["it", "arts", "medical"];

export const COURSES_DATA = [
  //   01
  {
    id: "01",
    slug: "pf1-it",
    lesson: 48,
    rating: 4.5,
    students: 10,
    category: COURSES_CATEGORIES[0],
    duration: "29",
    isPublished: true,
    isOffered: true,
    isFeatured: true,
    courseCode: "PF-1",
    level: "Basic-Intermediate",
    imgUrl: "assets/images/courses/it/it.webp",
    instructor: "Hamza Khalid Bhutta",
    title: "PROGRAMMING FUNDAMENTALS",
    enrollNow: "https://forms.gle/KKyRSWRMS7BDviC36",
    subHeading: "BOOTCAMP 2023 a way to PROGRAMMING FUNDAMENTALS (PF-1)",
    description: `
              Designed to open up a world of opportunities, essential
              skills and knowledge required to fast-track your career and make a meaningful
              impact in the dynamic world of web technology. Its an exciting journey with clear
              objectives to cultivate your web design and development talents from seed to full bloom.`,
    modules: [
      {
        id: "1",
        name: "Introduction to Programming Fundamentals and language Basics",
        description: `
                  - Course overview
                  - What is programming and different terms used in programming
                  - Writing and running your first program.
                  - Variables, data types, and basic input/output.
                  - history, and installation.
                  - Writing and running your first Java program.
                  - Operators and expressions.
                  - Control structures: if statements. 
                  `,
        lectures: [
          {
            title: "Lecture-1 | Part-1 of 2",
            link: "https://www.youtube.com/embed/bqAXRarzdww?si=RpbDvc0JWCgTcYtF",
            description: `
                      🔥 Topics covered:  
                      ✔️ What is Problem Solving?  
                      ✔️ What is Algorithm?  
                      ✔️ What is pseudo code?  
                      ✔️ What is a Flowchart?  
                      ✔️ What is a Program?  
                      ✔️ What is Programming?  
                      ✔️ What is Binary Language?  
                      ✔️ What is the basic working Idea of Binary Language?  `,
          },
          {
            title: "Lecture-1 | Part-2 of 2",
            link: "https://www.youtube.com/embed/YLM-XDk0liA?si=A3A2epk2JwPi9368",
            description: `
                      🔥 Topics covered:
                      ✔️ Summary of part-1 
                      ✔️ Data units used in binary language 
                      ✔️ How to communicate with the computer? `,
          },

          {
            title: "Lecture-2 | Part-1 of 2",
            link: "https://www.youtube.com/embed/B1OQqP_fzCA?si=mpG-7_Ch38eZ7HAY",
            description: `
                      🔥 Topics covered:
                      ✔️ Recap
                      ✔️ Example: How different people who speak different languages communicate?
                      ✔️ How translators like Compiler, Interpreter, and Assembler translates HLL to LLL to bridge communication gap?
                      ✔️ Difference between High, Middle and Low Level Languages?
                      ✔️ Difference between Compiler and Interpreter? `,
          },
          {
            title: "Lecture-2 | Part-2 of 2",
            link: "https://www.youtube.com/embed/F3smxbM8ypg?si=XQKTHcih-NBmv3q0",
            description: `            
                      🔥 Topics covered in today's Lecture:
                      ✔️ Recap of part-1 lec-2
                      ✔️ What are the three ways to convert the program from High Level Language to Low Level Language?
                      ✔️ What are Compilation, Interpretation, and Just-in-time Compilation?
                      ✔️ What is meant by Syntax?
                      ✔️ Term Programmer
                      ✔️ Important terms to understand the process of Compilation, Interpretation and Just in Time Compilation
                      ✔️ What is algorithm?
                      ✔️ What is a Program?
                      ✔️ What are text Editor and IDE?
                      ✔️ What is File and File Extension?
                      ✔️ What is Source Code?
                      ✔️ What is a Source File?
                      ✔️ What is an Object code?
                      ✔️ What is an object file?
                      ✔️ What is a Machine code?
                      ✔️ What is Executable file
                      ✔️ What is meant by Machine code is platform dependent?
                      ✔️ What is a machine in the context of programming?
                      ✔️ How machine runs any program?`,
          },
          {
            title: "Lecture-3 | Part-1 of 2",
            link: "https://www.youtube.com/embed/n2kLD-FEWrs?si=TJ1h5bX9ygrQjZor",
            description: `
                      🔥 Topics covered in today's Lecture:
                      ✔️ Recap of lec-2
                      ✔️ What are the three ways to convert the program from High Level Language to Low Level Language?
                      ✔️ What is Compiler, Interpreter, and Just-in-time Compiler?
                      ✔️ How Compiler works?
                      ✔️ What are the features of a Compiler?
                      ✔️ What are the advantages and disadvantages of compiler based languages?
                      ✔️ How Interpreter works?
                      ✔️ What are the features of an Interpreter?
                      ✔️ What are the advantages and disadvantages of interpreter based languages?
                      ✔️ How Just in time compiler works?
                      ✔️ What are the features of a Just in time compilers?`,
          },
        ],
      },
      {
        id: "2",
        name: "Setting Up the Development Environment",
        description: `
                    - Choosing an IDE 
                    - Basic Command Line Usage in JavaScript
                    - Version Control with Git 
                    - Deploying web applications to servers or cloud platforms (e.g., Netlify)
                    - Domain management and DNS
                    - Continuous integration and continuous deployment (CI/CD) pipelines for JavaScript
                    - Setting up a development environment for JavaScript`,
        lectures: [],
        assignment:
          "Create a basic CI/CD pipeline for a project and deploy it to a cloud platform.",
        recommendedReading: [
          {
            title: "Pro Git",
            author: "Scott Chacon and Ben Straub",
            link: "https://git-scm.com/book/en/v2",
          },
          {
            title:
              "Continuous Delivery: Reliable Software Releases through Build, Test, and Deployment Automation",
            author: "Jez Humble and David Farley",
          },
        ],
      },
      {
        id: "3",
        name: "Basics of Programming Languages",
        description: `
                    - Variables 
                    - Data Types 
                    - Operators
                    - Expressions`,
        lectures: [],
        assignment:
          "Write a program that demonstrates the use of variables, data types, operators, and expressions.",
        recommendedReading: [
          {
            title: "Eloquent JavaScript",
            author: "Marijn Haverbeke",
            link: "https://eloquentjavascript.net/",
          },
        ],
      },
      {
        id: "4",
        name: "Control Flow",
        description: `
                    - Conditionals
                    - Loops
                    - Branching
                    - Functions`,
        lectures: [],
        assignment:
          "Implement a program that utilizes conditionals, loops, and functions.",
        recommendedReading: [
          {
            // eslint-disable-next-line no-script-url
            title: "JavaScript: The Good Parts",
            author: "Douglas Crockford",
          },
        ],
      },
      {
        id: "5",
        name: "Data Structures",
        description: `
                    - Arrays
                    - Lists 
                    - Stacks
                    - Queues`,
        lectures: [],
        assignment:
          "Implement a program that uses arrays, lists, stacks, and queues.",
        recommendedReading: [
          {
            title: "Data Structures and Algorithms",
            author: "Michael McMillan",
          },
        ],
      },
      {
        id: "6",
        name: "Object-Oriented Programming (OOP)",
        description: `
                    - Classes
                    - Objects
                    - Inheritance
                    - Polymorphism`,
        lectures: [],
        assignment: "Design and implement a simple OOP-based program.",
        recommendedReading: [
          { title: "Object-Oriented JavaScript", author: "Stoyan Stefanov" },
        ],
      },
      {
        id: "7",
        name: "Error Handling and Debugging",
        description: `
                    - Exception Handling
                    - Debugging Techniques`,
        lectures: [],
        assignment:
          "Debug a provided code snippet and write a report on the debugging process.",
        recommendedReading: [
          {
            title: "Secrets of the JavaScript Ninja",
            author: "John Resig and Bear Bibeault",
          },
        ],
      },
      {
        id: "8",
        name: "File Handling and Networking Basics",
        description: `
                    - Reading and Writing Files
                    - File Formats
                    - Introduction to Networking`,
        lectures: [],
        assignment:
          "Create a program that reads from and writes to files and communicates over a network.",
        recommendedReading: [
          { title: "Node.js Design Patterns", author: "Mario Casciaro" },
        ],
      },
      {
        id: "9",
        name: "Introduction to Databases and Advanced Concepts",
        description: `
                    - Relational Databases
                    - SQL
                    - NoSQL Databases
                    - Database Design Principles`,
        lectures: [],
        assignment:
          "Create a relational database, write SQL queries, and explore a NoSQL database.",
        recommendedReading: [
          {
            title: "MongoDB: The Definitive Guide",
            author: "Kristina Chodorow",
          },
        ],
      },
      {
        id: "10",
        name: "Advanced Algorithms and Data Structures",
        description: `
                    - Advanced Sorting and Searching Algorithms
                    - Trees
                    - Graphs
                    - Dynamic Programming`,
        lectures: [],
        assignment:
          "Implement an advanced algorithm and analyze its performance.",
        recommendedReading: [
          { title: "Algorithms", author: "Robert Sedgewick and Kevin Wayne" },
        ],
      },
      {
        id: "11",
        name: "Web Development Best Practices",
        description: `
                    - Code quality and maintainability
                    - Accessibility and web standards
                    - Web security best practices`,
        lectures: [],
        assignment:
          "Develop a web application incorporating best practices. Evaluate code quality, ensure accessibility, and implement security measures.",
        recommendedReading: [
          {
            title: "High-Performance Browser Networking",
            author: "Ilya Grigorik",
          },
        ],
      },
      {
        id: "12",
        name: "Final Assessment and Graduation",
        description: `
                    - Individual or group project to apply skills learned throughout the course
                    - Development of a real-world web application 
                    - Presentation and demonstration of the project
                    - Integration of Concepts Learned
                    - Project Planning
                    - Technical Interview Preparation`,
        lectures: [],
        assignment:
          "Develop and present an individual or group project, applying the skills learned throughout the course. Prepare for a technical interview.",
        recommendedReading: [
          {
            title: "Cracking the Coding Interview",
            author: "Gayle Laakmann McDowell",
          },
        ],
      },
    ],
  },
  //   02
  {
    id: "02",
    slug: "wdd1-it",
    lesson: 48,
    rating: 4.5,
    students: 18,
    category: COURSES_CATEGORIES[0],
    duration: "29",
    isPublished: true,
    isOffered: true,
    isFeatured: true,
    courseCode: "WDD-1",
    level: "Basic-Intermediate",
    imgUrl: "assets/images/courses/it/it.webp",
    instructor: "Hamza Khalid Bhutta",
    title: "WEB DESIGN AND DEVELOPMENT",
    enrollNow: "https://forms.gle/VYSBvDpz4uR71zyL6",
    subHeading: "BOOTCAMP 2023 a way to WEB DESIGN AND DEVELOPMENT (WDD-1)",
    description: `WDD is a 12-week course designed to open up a world of opportunities, essential
              skills and knowledge required to fast-track your career and make a meaningful
              impact in the dynamic world of web technology. Its an exciting journey with clear
              objectives to cultivate your web design and development talents from seed to full bloom.`,
    modules: [
      {
        id: "1",
        name: "Environment, Version Control and Collaboration",
        description: `
                  - Overview of web technologies
                  - Git and version control
                  - Code reviews and collaboration tools
                  - Github (Account creation)
                  - VSCode
                  - LiveShare extension
                  - Material Icons extension
                  - Netlify
                  - Mini Project/Assignment
                  `,
        lectures: [],
      },
      {
        id: "2",
        name: "Introduction to Web Development",
        description: `
                  - Overview of web technologies
                  - HTML and CSS fundamentals
                  - HTML5 and semantic markup
                  - Setting up a development environment`,
        lectures: [],
      },
      {
        id: "3",
        name: "Responsive Web Design",
        description: `
                  - Introduction to responsive design
                  - CSS and CSS3 for styling and layout
                  - Mobile-first design
                  - Media queries, Flex Box, Grids
                  - Responsive frameworks (e.g., Bootstrap)`,
        lectures: [],
      },
      {
        id: "4",
        name: "JavaScript Fundamentals",
        description: `
                  - Introduction to JavaScript 
                  - Core concepts of JavaScript 
                  - Working with variables, functions, and objects
                  - DOM manipulation and event handling
                  - Variables, data types, and operators
                  - Control flow and functions`,
        lectures: [],
      },
      {
        id: "5",
        name: "Front-End Frameworks",
        description: `
                  - Introduction to front-end frameworks (e.g., React)
                  - Create a single-page application using a front-end framework
                  - Component-based architecture
                  - State managementState management in front-end development`,
        lectures: [],
      },
      {
        id: "6",
        name: "Back-End Development",
        description: `
                  - Server-side scripting (e.g., Node.js) 
                  - Handling data with databases fundamentals (MySql, Xampp)
                  - API development`,
        lectures: [],
      },
      {
        id: "7",
        name: "Integrating front-end and back-end",
        description: `
                  - Server-side scripting (e.g., Node.js)
                  - Handling data with databases fundamentals (MySql, Xampp)
                  - API development`,
        lectures: [],
      },
      {
        id: "8",
        name: "Web Development Tools and Workflow",
        description: "This is the description for module 8.",
        lectures: [],
      },
      {
        id: "9",
        name: "Deployment and Hosting",
        description: `
                  - Build tools (e.g., Webpack, Gulp)
                  - Debugging and browser developer tools
                  - Performance optimization and testing`,
        lectures: [],
      },
      {
        id: "10",
        name: "Web Development Best Practices",
        description: `
                  - Deploying web applications to servers or cloud platforms (e.g. Netlify)
                  - Domain management and DNS
                  - Continuous integration and continuous deployment (CI/CD) pipelines`,
        lectures: [],
      },
      {
        id: "11",
        name: "Project",
        description: `
                  - Code quality and maintainability
                  - Accessibility and web standards
                  - Web security best practices`,
        lectures: [],
      },
      {
        id: "12",
        name: "Final Assessment and Graduation",
        description: `
                  - Individual or group project to apply skills learned throughout course
                  - Development of a real-world web application
                  - Presentation and demonstration of the project `,
        lectures: [],
      },
    ],
  },
  //   03
  {
    id: "03",
    slug: "gd1-it",
    lesson: 16,
    rating: 4.7,
    students: 5,
    category: COURSES_CATEGORIES[0],
    duration: "16",
    level: "Intermediate",
    isPublished: true,
    isOffered: true,
    isFeatured: true,
    courseCode: "GD-1",
    imgUrl: "assets/images/courses/it/it1.webp",
    instructor: "Maryam Farooq",
    title: "Professional Graphics Design",
    enrollNow: "https://forms.gle/Jmg1ctAN7iXyu1hX9",
    subHeading: "BOOTCAMP 2023 a way to Professional Graphics Design (GD-1)",
    description: `GD is a 12-week course designed to open up a world of opportunities, essential skills
              and knowledge required to fast-track your career and make a meaningful impact in
              the dynamic world of web technology. Its an exciting journey with clear objectives to
              cultivate your web design and development talents from seed to full bloom.
              <br />Invest in your creative future with Seed to Tree Online Academy's Graphics
              Designing course. Unleash your creativity, sharpen your skills, and embark on a
              fulfilling design journey that opens doors to endless possibilities in the world of
              graphic design. Don't miss out on this opportunity to turn your passion into a
              profession! Join us today and let your creativity flourish.`,
    modules: [
      {
        id: "1",
        name: "Introduction to Graphic Design",
        description: `
                  - Understanding the fundamentals of graphic design
                  - Design principles: Balance, contrast, alignment, proximity
                  - Typography and its significance
                  - Mini Project/Assignment:
                  `,
        lectures: [],
      },
      {
        id: "2",
        name: "Design Software Tools",
        description: `
                  - Introduction to Adobe Creative Suite (Photoshop, Illustrator) \n
                  - Basics of working with design software \n
                  - Designing your first project: Poster or brochure \n`,
        lectures: [],
      },
      {
        id: "3",
        name: "Color Theory and Application",
        description: `
                  - Understanding color psychology 
                  - Color modes (RGB, CMYK, Pantone) 
                  - Creating harmonious color schemes`,
        lectures: [],
      },
      {
        id: "4",
        name: "Layout and Composition",
        description: `
                  - Grid systems in design \n
                  - Creating effective layouts \n 
                  - Using white space and hierarchy`,
        lectures: [],
      },
    ],
  },
  //   04
  {
    id: "04",
    slug: "oet1-arts",
    lesson: 16,
    rating: 4.7,
    students: 5,
    duration: "18",
    category: COURSES_CATEGORIES[1],
    level: "Advance",
    isPublished: true,
    isOffered: true,
    isFeatured: true,
    courseCode: "OET-1",
    instructor: "Dr, Sehar bano",
    imgUrl: "assets/images/courses/arts/oet.webp",
    title: "Occupational English Test (OET)",
    enrollNow: "https://forms.gle/b3B439jRevHEzUjJ9",
    subHeading: `CRASH COURSE 2023 a way to Occupational English Test (OET)`,
    description:
      "Are you looking for a personalized and effective way to prepare for the OET exam? Look no further than our OET online customizable sessions! Our sessions are designed to cover all four modules of the OET exam: Reading, Writing, Listening, and Speaking. We also offer a variety of customization options to meet your individual needs and goals.",
    modules: [
      {
        id: "1",
        name: "Module 1",
        description: "This is the description for module 1.",
        lectures: [],
      },
      {
        id: "2",
        name: "Module 2",
        description: "This is the description for module 2.",
        lectures: [],
      },
      {
        id: "3",
        name: "Module 3",
        description: "This is the description for module 3.",
        lectures: [],
      },
      {
        id: "4",
        name: "Module 4",
        description: "This is the description for module 4.",
        lectures: [],
      },
    ],
  },
  //   05
  {
    id: "05",
    slug: "ielts1-arts",
    lesson: 16,
    rating: 4.7,
    students: 5,
    duration: "18",
    category: COURSES_CATEGORIES[1],
    level: "Advance",
    isPublished: false,
    isOffered: false,
    isFeatured: false,
    courseCode: "IELTS-1",
    instructor: "",
    imgUrl: "assets/images/courses/arts/oet.webp",
    title: " International English Language Testing System",
    enrollNow: "",
    subHeading: `CRASH COURSE 2023 a way to International English Language Testing System (IELTS)`,
    description:
      "CRASH COURSE 2023 a way to  International English Language Testing System (IELTS)",
    modules: [
      {
        id: "module-1",
        name: "Module 1",
        description: "This is the description for module 1.",
        lectures: [],
      },
      {
        id: "module-2",
        name: "Module 2",
        description: "This is the description for module 2.",
        lectures: [],
      },
      {
        id: "module-3",
        name: "Module 3",
        description: "This is the description for module 3.",
        lectures: [],
      },
      {
        id: "module-4",
        name: "Module 4",
        description: "This is the description for module 4.",
        lectures: [],
      },
    ],
  },
  //   06
  {
    id: "06",
    slug: "tm1-arts",
    lesson: 16,
    rating: 4.8,
    students: 5,
    duration: "18",
    category: COURSES_CATEGORIES[1],
    level: "Basic to Advance",
    isPublished: true,
    isOffered: false,
    isFeatured: false,
    courseCode: "TM-1",
    instructor: "",
    imgUrl: "assets/images/courses/arts/arts.webp",
    title: "BOOTCAMP 2023 a way to Teaching Methodology",
    subHeading: "",
    description: "",
    enrollNow: "",
    modules: [
      {
        id: "module-1",
        name: "Module 1",
        description: "This is the description for module 1.",
        lectures: [],
      },
      {
        id: "module-2",
        name: "Module 2",
        description: "This is the description for module 2.",
        lectures: [],
      },
      {
        id: "module-3",
        name: "Module 3",
        description: "This is the description for module 3.",
        lectures: [],
      },
      {
        id: "module-4",
        name: "Module 4",
        description: "This is the description for module 4.",
        lectures: [],
      },
      {
        id: "module-5",
        name: "Module 5",
        description: "This is the description for module 6.",
        lectures: [],
      },
      {
        id: "module-6",
        name: "Module 6",
        description: "This is the description for module 6.",
        lectures: [],
      },
      {
        id: "module-7",
        name: "Module 7",
        description: "This is the description for module 7.",
        lectures: [],
      },
      {
        id: "module-8",
        name: "Module 8",
        description: "This is the description for module 8.",
        lectures: [],
      },
      {
        id: "module-9",
        name: "Module 9",
        description: "This is the description for module 9.",
        lectures: [],
      },
      {
        id: "module-10",
        name: "Module 10",
        description: "This is the description for module 10.",
        lectures: [],
      },
      {
        id: "module-11",
        name: "Module 11",
        description: "This is the description for module 11.",
        lectures: [],
      },
      {
        id: "module-12",
        name: "Module 12",
        description: "This is the description for module 12.",
        lectures: [],
      },
    ],
  },
];
